<template>
  <div class="projectMainPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入关键词"
      show-action
      shape="round"
      @input="onSearch"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-radio-group v-model="radio">
          <van-cell-group class="baseNone baseSalary">
            <van-cell
              :title="`${projectItem.projectName}`"
              clickable
              v-for="projectItem in itemMainList"
              :key="projectItem.id"
              @click="selectitem(projectItem)"
            >
              <van-radio slot="right-icon" :name="projectItem.projectName" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "projectMain",
  data() {
    return {
      radio: "", //选中的项目
      keyValues: "",
      searchKeyword: "", //搜索的姓名人员
      total: "", //统计计算
      itemMainList: [],
      selecItemList: [],
      projectData: "",
      itemId: "",
      Itempage: 0,
      pageSize: 1000,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据

      clientType: "", //手机类型
    };
  },
  props: {
    selectTypes: { type: String, default: "" },
  },
  mounted() {
    this.getProjectList();
  },
  methods: {
    onSearch() {
      let _this = this;
      _this.keyValues = _this.searchKeyword;
      _this.reloadPage();
    },
    getProjectList() {
      let _this = this;
      if (
        _this.Itempage != 0 &&
        _this.Itempage * _this.pageSize >= parseInt(_this.total)
      ) {
        return;
      }
      _this.Itempage += 1;

      _this.$api.administration.administration.bonus
        .projectList(_this.Itempage, _this.pageSize, {
          keyValues: _this.keyValues,
          type: _this.selectTypes,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.total = parseInt(res.data.total);
            _this.selecItemList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            if (_this.Itempage * _this.pageSize >= _this.total) {
              _this.finished = true;
            } else {
              _this.getProjectList();
            }
          } else {
            _this.selecItemList = [];
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
    viewLists() {
      this.itemMainList = this.itemMainList.concat(this.selecItemList);
    },
    selectitem(item) {
      let _this = this;
      _this.radio = item.projectName;
      _this.itemId = item.id;
      _this.projectData = item;
    },
    closeRetinuePicker() {
      this.projectData = "";
      this.$emit("setItems", "");
    },
    saveRetinue() {
      let _this = this;
      this.$emit("setItems", _this.projectData);
      _this.projectData = new Object();
    },

    reloadPage() {
      this.radio = "";
      this.Itempage = 0;
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.itemMainList = [];
      this.getProjectList();
    },
  },
  watch: {
    selectTypes() {
      console.log("qiekuan")
      this.reloadPage();
    },
  },
};
</script>
<style lang="less" >
.projectMainPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }

  .list-content {
    height: calc(100% - 95px);
    overflow-y: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .baseSalary {
    .van-cell__title {
      span {
        display: inline-block;
        width: 85%;
        overflow: hidden;
      }
    }
  }
  .roleBtn {
    z-index: 100000;
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    border-top: 1px solid #f6f6f6;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>